import React, { useEffect, useState } from 'react';
import { Redux, Slices } from 'spwa-ui-library';
import { FormattedMessage, useIntl } from 'react-intl';
import throttle from 'lodash/throttle';
import cloneDeep from 'lodash/cloneDeep';
import { Button, Tab, Tabs } from '@material-ui/core';
// import Skeleton from 'react-loading-skeleton';
// LOCAL IMPORTS
import ProductConfigurableGroup from '../../components/ProductConfigurableGroup';
import ProductOptionGroup from '../../components/ProductOptionGroup';
import ProductAddToCart from '../../components/ProductAddToCart/index.jsx';
import CustomizedBox from '../../components/ProductTile/CustomizedBox';
import { generateCustomization, getDefaultDependent } from 'spwa-ui-library/esm/utils/helper';
import css from './index.module.scss';
import noImg from '../../assets/no-itm.png';
import BackButton from '../../components/BackButton';
import { useLocation, useNavigate } from '@reach/router';
const { useSelector, useDispatch } = Redux;
const { selectCurrentCountry } = Slices.profileSlice;
const { getVariantImageUrlBase, getClusterId } = Slices.configSlice;
const { updateProductPayload } = Slices.tempCartSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const {
  selectProductEntities,
  setStatus,
  selectProductFetchStatus,
  setDetailsFetched,
  resetFetchedDataCond,
  getProductInfo,
} = Slices.productSlice;

// eslint:fix cardWrapClass is defined to resolve eslint fix
const cardWrapClass = '.card-wrap';
function ProductCustomize({
  selectedProduct,
  setSelectedSize,
  setOptMainId,
  addCart,
  isDesktop,
  productID,
  categoryID,
  resetButton,
  menuItem,
  SetResetDependent,
  resetDependent,
  checkDependent,
  setCheckDependent,
}) {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const productRoute = '';
  const [isSticky, setIsSticky] = React.useState(false);
  const locationSearch = new URLSearchParams(location.search);
  const isBundleItem = locationSearch.has('main_product') || false;
  const mainProductId = locationSearch.get('main_product');
  const stepId = locationSearch.get('step');
  const tempItems = useSelector((state) => state.tempCart);
  const productsMap = useSelector(selectProductEntities);
  const [removeCust, setRemoveCust] = useState(false);
  const [customToShow, setCustomToShow] = useState(selectedProduct || {});
  const [handleClick, setHandleClick] = useState(false);
  const [tabValue, setTabVal] = useState(0);
  const productStatus = useSelector(selectProductFetchStatus);
  const isBackNotPressed = localStorage.getItem('isBackNotPressed') === 'true';
  const variantImageBase = useSelector(getVariantImageUrlBase);
  const clusterId = useSelector(getClusterId);
  const defaultAddress = useSelector(selectDefaultAddress);
  const [currentCustomization, setCurrentCustomization] = useState(null);

  useEffect(() => {
    const customizedProducts = tempItems?.customize?.items.filter(
      (item) => item.id == (isBundleItem ? mainProductId : productID)
    );

    let mainProductObj = productsMap[mainProductId || productID];
    let bundleId;
    if (mainProductObj?.typeId == 'bundle_group') {
      if (customizedProducts?.[0]?.additionalInfo?.selectedBundleId) {
        bundleId = customizedProducts?.[0]?.additionalInfo?.selectedBundleId;
      } else if (mainProductObj?.isBOGO) {
        let steps = Object.keys(customizedProducts?.[0]?.bundle || {});
        steps = steps?.[steps.length - 1] || [0];
        bundleId = (steps - (steps % 10)) / 10;
      }
    }

    // TODO:  Temporary fix for refresh scenario
    setTimeout(async () => {
      await dispatch(
        getProductInfo({
          id: bundleId && !mainProductObj?.isBOGO ? bundleId : productID,
          cluster: clusterId,
          service: defaultAddress?.addressSubType || 'DELIVERY',
          categoryId: categoryID || mainProductObj?.categories?.[0],
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      );
    }, 1500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // USE DISPATCH
  const dispatch = useDispatch();
  // FINAL CUSTOMIZE ITEMS PRICE

  let productSteps;
  if (isBundleItem) {
    if (
      productsMap[mainProductId]?.isBOGO ||
      productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
    ) {
      const optionId = parseInt(locationSearch.get('option'));

      let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
      });

      if (!bgSteps?.id) {
        bgSteps = productsMap[bgSteps];
      }

      if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
        bgSteps = productsMap[bgSteps?.id];
      }

      productSteps = bgSteps?.steps?.find((step) => step?.id == stepId);
    } else {
      productSteps = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
    }
    selectedProduct = productSteps?.['options']?.find((option) => option.id == selectedProduct?.id);
  }

  if (!selectedProduct) {
    selectedProduct = productsMap[productID];
  }

  const priceVal = tempItems.data?.cartValue || tempItems.customize?.cartValue;

  let currentProduct = JSON.parse(JSON.stringify(selectedProduct || {}));
  let currentProductVariation;
  let tabLists = [];
  let lists = [];

  if (!isBundleItem) {
    const customizedProduct =
      tempItems.data.items.find((prod) => prod.id == currentProduct.id) ||
      tempItems.customize.items.find((prod) => prod.id == currentProduct.id);
    // update variants
    const variationArray = [-1, -1, -1];
    if (customizedProduct?.variants) {
      currentProduct['variants'] = currentProduct.variants.map((variant, index) => {
        const selectedOption = customizedProduct?.variants[variant.id];
        variationArray[index] = selectedOption;
        variant['options'] = variant?.options.map((option) => {
          option['isSelected'] = option['id'] == selectedOption ? 1 : 0;
          return option;
        });
        return variant;
      });

      currentProductVariation = currentProduct?.items?.find((item) => {
        let isVariantSame = true;
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }
        variationArray.forEach((variant, index) => {
          if (itemInfo[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });
      currentProductVariation = currentProductVariation?.id
        ? currentProductVariation
        : productsMap[currentProductVariation];
    }
  } else {
    const variantObj = { variants: {} };
    // eslint-disable-next-line no-unused-expressions
    currentProduct?.variants?.forEach((variant, index) => {
      const selectedOption = variant?.options.filter((option) => option?.isSelected == 1);
      if (selectedOption.length > 0) {
        variantObj['variants'][variant?.id] = selectedOption[0]?.id;
      }
    });

    let allProducts = [];
    for (let step of Object.values(
      tempItems.data.items.find((prod) => prod.id == mainProductId)?.['bundle'] || {}
    )) {
      for (let [pId, pObj] of Object.entries(step)) {
        allProducts = [...allProducts, { ...pObj, id: pId }];
      }
    }

    const customizedProduct =
      tempItems.data.items.find((prod) => prod.id == mainProductId)?.['bundle']?.[stepId]?.[
        currentProduct?.id
      ] ||
      tempItems.customize.items.find((prod) => prod.id == mainProductId)?.['bundle']?.[stepId]?.[
        currentProduct?.id
      ] ||
      allProducts?.find((item) => item.id == currentProduct.id) ||
      variantObj;

    let variationArray = [-1, -1, -1];
    if (customizedProduct?.variants) {
      let i = 0;
      for (let [variantId, optionId] of Object.entries(customizedProduct?.variants)) {
        variationArray[i] = optionId;
        i++;
      }
    }

    currentProductVariation = currentProduct?.items?.find((item) => {
      let isVariantSame = true;
      let itemInfo;
      if (!item?.id) {
        itemInfo = productsMap[item];
      } else {
        itemInfo = item;
      }
      variationArray.forEach((variant, index) => {
        if (itemInfo[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });
  }

  if (currentProductVariation && !currentProductVariation?.id) {
    currentProductVariation = productsMap[currentProductVariation];
  }

  if (!currentProductVariation?.steps?.[0]?.options) {
    currentProductVariation = productsMap[currentProduct?.id]?.items?.find(
      (itm) => itm.id == currentProductVariation?.id
    );
  }

  const steps = currentProductVariation?.steps;

  let arr = [];
  let tabs = [];
  if (
    currentProduct?.variants?.[0]?.options?.length ||
    (currentProduct?.bundleTypeId == 'bundle' && currentProduct?.steps?.length)
  ) {
    // eslint-disable-next-line no-unused-expressions
    (
      (currentProduct?.variants?.length ? currentProduct?.variants : currentProduct?.steps) || []
    ).forEach((item) => {
      const { subtitle, id } = item;
      let value = `${subtitle.replace(/[\W_]/g, '').split(' ').join('')}-${id}`;
      arr.push(value);
      tabs.push({ title: subtitle, id: value, position: id });
    });
  }
  if (steps && steps?.length > 0) {
    steps.forEach((item) => {
      const { subtitle, isDependent, id } = item;
      let value = `${subtitle.replace(/[\W_]/g, '').split(' ').join('')}-${id}`;
      arr.push(value);
      tabs.push({ title: subtitle, id: value, isDependent, position: id });
    });
  }
  if (arr && arr.length > 0) {
    lists = arr;
  }
  if (tabs && tabs.length > 0) {
    tabLists = tabs;
  }

  const checkReset = () => {
    setRemoveCust(true);
    resetButton();
    const defaultCondiment = getDefaultDependent(productsMap[selectedProduct?.id]?.steps || []);
    setCheckDependent && setCheckDependent(defaultCondiment);
  };

  useEffect(() => {
    const defaultCondiment = getDefaultDependent(productsMap[selectedProduct?.id]?.steps || []);
    setCheckDependent && setCheckDependent(defaultCondiment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct]);

  useEffect(() => {
    if (resetDependent) {
      const defaultCondiment = getDefaultDependent(productsMap[selectedProduct?.id]?.steps || []);
      setCheckDependent && setCheckDependent(defaultCondiment);
      SetResetDependent(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetDependent]);

  const getCustomize = () => {
    const inCusto = tempItems?.customize?.items?.findIndex(({ id }) => id === +productID);
    let other = [];
    menuItem?.items?.length &&
      menuItem.items.forEach((inner) => {
        other.push(productsMap[inner]);
      });
    const ItemCustomize = { ...menuItem, items: other };
    const getCustomizeVal = generateCustomization(
      tempItems?.customize?.items[inCusto],
      ItemCustomize
    );

    return (
      <CustomizedBox
        route={productRoute}
        customizeDescription={getCustomizeVal}
        productObj={customToShow}
        reset={true}
        resetButton={checkReset}
      />
    );
  };

  const getMidValue = (ele) => {
    let eleRect;
    if (ele) {
      eleRect = ele.getBoundingClientRect();
    }
    const v = eleRect?.height + eleRect?.bottom;
    return { sum: v, mid: v / 2, id: ele.id, height: eleRect.height };
  };

  const getSumHeightsOfCards = (items) => {
    let sumAll = 0;
    if (items && items.length) {
      items.forEach((tt) => {
        sumAll += tt.height;
      });
    }
    return sumAll;
  };

  function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  }

  function scrollTo(element, to, duration) {
    let start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 10;

    let animateScroll = function () {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  }
  // eslint:fix renderTermsList is declared to remove duplicate code from
  const renderTermsList = (list) => {
    return list.filter(({ position, ingredient, isDependent }) => {
      if (isDependent && !checkDependent?.includes(position) && ingredient === 0) {
        return false;
      }
      return true;
    });
  };
  const handleScroll = throttle(() => {
    const newFilter = tabLists && tabLists.length > 0 && renderTermsList(tabLists);

    if (handleClick) {
      return false;
    }
    let ele = document.querySelector(cardWrapClass);
    // ON SCROLL FIRED
    const values = [];
    lists &&
      lists.length > 0 &&
      lists.forEach((text) => {
        const target = document.getElementById(text);
        if (target) {
          values.push(getMidValue(target));
        }
      });
    //SUM OF ALL THE ITEMS
    let sumAll = getSumHeightsOfCards(values);
    // SET CURRENT ACTIVE ID
    const headDiff = ele.scrollHeight + 150 - sumAll;
    let id = '';

    let findIndex;
    tabLists &&
      tabLists.length > 0 &&
      tabLists.forEach(({ position, isDependent, ingredient, id: itemId }) => {
        if (isDependent && !checkDependent?.includes(position) && ingredient === 0) {
          return (findIndex = itemId);
        }
      });

    if (ele.scrollTop >= ele.scrollHeight - 60 - ele.offsetParent.scrollHeight) {
      id = values[values.length - 1]?.id;
      let index = tabLists && tabLists.length > 0 && tabLists.findIndex((item) => item.id === id);
      if (!handleClick) {
        const item = newFilter[findIndex ? index - 1 : index];
        localStorage.setItem(
          'activeIndex',
          `${item?.title?.replace(/’/g, '').split(' ').join('')}-${item?.id}`
        );
        setTabVal(findIndex ? index - 1 : index);
      }
    } else if (values) {
      for (let i = 0; i < values.length - 2; i++) {
        if (
          (values[i].sum > ele.scrollTop + headDiff && values[i + 1].sum) <
          ele.scrollTop + headDiff
        ) {
          id =
            (values[i].sum + values[i + 1].sum) / 2 - (headDiff + 180) > ele.scrollTop + headDiff
              ? values[i].id
              : values[i + 1].id;
        }
      }

      let filteredList = tabLists;
      if (findIndex) {
        filteredList =
          tabLists &&
          tabLists.length > 0 &&
          tabLists.filter((item) => item.id.trim() !== findIndex.trim());
      }

      let itemIndex =
        filteredList && filteredList.length > 0 && filteredList.findIndex((item) => item.id === id);
      if (!handleClick) {
        if (itemIndex > -1) {
          const item = newFilter[itemIndex];
          localStorage.setItem(
            'activeIndex',
            `${item.title
              .replace(/[,.-’]/g, '')
              .split(' ')
              .join('')}-${item.position}`
          );
          setTabVal(itemIndex ? itemIndex : '');
        } else {
          setTabVal(0);
        }
      }
    }
  }, 200);

  useEffect(() => {
    let ele = document.querySelector(cardWrapClass);
    let interval;

    if (ele && !!lists.length) {
      let isScroll = handleClick ? '' : 'scroll';
      interval = setTimeout(() => {
        ele.addEventListener(isScroll, handleScroll, { passive: true });
      }, 1000);
    }

    return () => {
      ele.removeEventListener('scroll', handleScroll, { passive: true });
      clearInterval(interval);
    };
  }, [handleClick, handleScroll, lists]);

  useEffect(() => {
    return () => {
      localStorage.removeItem('activeIndex');
      if (productStatus === 'succeeded') {
        dispatch(setStatus('loading'));
        dispatch(setDetailsFetched(false));
        dispatch(resetFetchedDataCond(false));
      }
      if (isBackNotPressed) {
        localStorage.removeItem('isBackNotPressed');
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, productStatus]);

  function LinkTab(props) {
    if (tabValue === 0 && props.value === 0) {
      localStorage.setItem('activeIndex', `${props.uniqueid}`);
    }
    return (
      <Tab
        component="a"
        textColor={parseInt(props.key) === parseInt(tabValue) ? 'var(--clr-primary-400)' : ''}
        onClick={(event) => {
          event.preventDefault();
          localStorage.setItem('activeIndex', props.uniqueid);
        }}
        {...props}
      />
    );
  }

  let renderTabs =
    tabLists &&
    tabLists.length > 0 &&
    tabLists.map(({ title, id, position, isDependent, ingredient }, key) => {
      let renderTab = '';
      if (isDependent && !checkDependent?.includes(position) && ingredient === 0) {
        renderTab = '';
      } else {
        renderTab = (
          <LinkTab
            uniqueid={`${title.replace(/[\W_]/g, '').split(' ').join('')}-${position}`}
            label={title}
            href={`#${id}`}
            key={key}
          />
        );
      }
      return renderTab;
    });
  // STR FUNCTION
  function convert(str) {
    return decodeURIComponent(JSON.parse('"' + str.replace(/"/g, '\\"') + '"'));
  }

  const handleTabChange = (e, value) => {
    setHandleClick((prev) => !prev);
    let ele = document.querySelector(cardWrapClass);
    const url =
      intl.locale === 'ar'
        ? convert(e.currentTarget.href.split('#')[1])
        : e.currentTarget.href.split('#')[1];
    const target = document.getElementById(url);
    let diffToBeSubtracted = value === 0 ? 125 : 100;
    let topPos = target?.offsetTop - diffToBeSubtracted;
    let targetTop = target?.offsetTop;

    // FOR MOBILE
    if (!isDesktop) {
      window.scrollTo({
        top:
          value === 0 ? targetTop - diffToBeSubtracted - 150 : targetTop - diffToBeSubtracted - 140,
        behavior: 'smooth',
      });
      localStorage.removeItem('activeIndex');
    }
    let topDiff = topPos - ele.scrollTop;
    // SET SCROLL TOP VALUE FOR TARGET
    if (target) {
      setTabVal(value);
      let topScroll = topPos;
      if (topDiff > 0 && topDiff / 2 < 140 && ele.scrollTop > 200) {
        topScroll -= 160;
      }

      if (topDiff > 0 && topDiff / 2 < 100 && ele.scrollTop > 200) {
        topScroll -= 80;
      }

      scrollTo(ele, topScroll, 600);
    }
    let time = isDesktop ? 1500 : 3000;
    setTimeout(() => {
      setHandleClick((prev) => !prev);
    }, time);
  };

  const handleMobileScroll = throttle(() => {
    if (handleClick) {
      return false;
    }

    const newFilter = tabLists && tabLists.length > 0 && renderTermsList(tabLists);

    if (!handleClick) {
      let ele = document.querySelector(cardWrapClass);
      // ON SCROLL FIRED
      let middleElement, viewportHeight;
      let topPos;
      lists.forEach(function (m) {
        const target = document.getElementById(m);
        if (target) {
          let pos = target.getBoundingClientRect().top + 240;
          viewportHeight = ele.clientHeight;
          if (pos > viewportHeight / 5.5 && pos < viewportHeight / 5.5) {
            middleElement = target?.id;
            topPos = target.offsetTop;
            return false; // stop iteration
          }

          if (Math.round(pos / 3 - 100) < 100) {
            middleElement = target?.id;
            topPos = target.offsetTop;
            return false; // stop iteration
          }
        }
      });

      let itemIndex;
      if (middleElement) {
        itemIndex =
          newFilter &&
          newFilter.length > 0 &&
          newFilter.findIndex((item) => item.id === middleElement);
      }
      if (itemIndex > -1) {
        setTabVal(itemIndex ? itemIndex : 0);
        scrollTo(ele, topPos, 600);
      }
      // FOR DEFAULT SELECT FOR FIRST ITEM
      if (topPos < 300) {
        setTabVal(0);
        scrollTo(ele, 60, 600);
      }
    }
  }, 500);

  useEffect(() => {
    let interval;
    if (lists.length) {
      let isScroll = handleClick ? '' : 'scroll';
      setTimeout(() => {
        interval = window.addEventListener(isScroll, handleMobileScroll, { passive: true });
      }, 800);
    }
    return () => {
      window.removeEventListener('scroll', handleMobileScroll, { passive: true });
      clearInterval(interval);
    };
  }, [handleClick, handleMobileScroll, lists.length]);
  React.useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;
      setIsSticky(scrollPosition > 100);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!currentCustomization) {
      const currentId = locationSearch.get('main_product');
      const currentCust = JSON.parse(
        JSON.stringify(tempItems.data.items.find((item) => item.id == currentId) || {})
      );
      const currentDeal = cloneDeep(currentCust);
      setCurrentCustomization(currentDeal);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleBack = (skipNavigation) => {
    window.localStorage.setItem('notShowBogoPopup', true);
    const pathname = location.pathname;
    const params = pathname.split('/');
    const locationSearch = new URLSearchParams(location.search);

    if (locationSearch.has('main_product')) {
      const mainProduct = locationSearch.get('main_product');
      const productId = params[params.length - 1];
      const step = locationSearch.get('step');
      const productCustomization = JSON.parse(
        JSON.stringify(tempItems.data.items.find((item) => item.id == mainProduct))
      );
      // debugger;
      const prevCustomization = tempItems?.customize?.items?.find((item) => item.id == mainProduct);

      let shouldUpdatePayload = !!productCustomization?.['bundle']?.[step]?.[productId]?.notAdded;

      if (productCustomization?.['bundle']?.[step]?.[productId]) {
        let customizationExists = !!productCustomization['bundle'][step][productId];
        delete productCustomization['bundle'][step][productId];
        if (customizationExists && prevCustomization?.['bundle']?.[step]?.[productId]) {
          productCustomization['bundle'][step][productId] =
            currentCustomization?.['bundle']?.[step]?.[productId] || {};
        }
      }
      if (productCustomization?.['subItem']?.[step]?.[productId]) {
        let customizationExists = !!productCustomization['subItem'][step][productId];
        delete productCustomization['subItem'][step][productId];
        if (customizationExists && prevCustomization?.['subItem']?.[step]?.[productId]) {
          productCustomization['subItem'][step][productId] =
            prevCustomization?.['subItem']?.[step]?.[productId] || {};
        }
      }
      if (productCustomization?.['items']?.[step]?.[productId]) {
        let customizationExists = !!productCustomization['items'][step][productId];
        delete productCustomization['items'][step][productId];
        if (customizationExists && prevCustomization?.['items']?.[step]?.[productId]) {
          productCustomization['items'][step][productId] =
            prevCustomization?.['items']?.[step]?.[productId] || {};
        }
      }

      let localProductBackup = window.localStorage.getItem('customizationData');
      let data = localProductBackup ? JSON.parse(localProductBackup) : productCustomization;

      if (localProductBackup) {
        dispatch(updateProductPayload({ data: data }));
        window.localStorage.removeItem('customizationData');
      }
      window.localStorage.setItem('backButtonPressed', 1);
    }
    if (!skipNavigation) {
      navigate(-1);
    }
  };

  useEffect(() => {
    let isInitialMount = true;
    const handlePopstate = (event) => {
      if (!isInitialMount) {
        if (!isBackNotPressed || (localStorage.getItem('stepId') == stepId && isBackNotPressed)) {
          handleBack(true);
        }
      }
    };

    window.addEventListener('popstate', handlePopstate);

    // Set the flag to false
    isInitialMount = false;

    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBackNotPressed]);

  let stepInfo;
  if (
    productsMap[mainProductId]?.isBOGO ||
    productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
  ) {
    const paramsStepId = parseInt(locationSearch.get('step'));
    const optionId = parseInt(locationSearch.get('option'));

    let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
      let itemInfo;
      if (!item?.id) {
        itemInfo = productsMap[item];
      } else {
        itemInfo = item;
      }

      return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
    });

    if (!bgSteps?.id) {
      bgSteps = productsMap[bgSteps];
    }

    if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
      bgSteps = productsMap[bgSteps?.id];
    }

    stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
  } else {
    stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
  }

  const productInfo = stepInfo?.options?.find((option) => option?.id == productID);
  let productOptions = productInfo?.items?.find((item) => {
    let itemInfo;
    if (!item?.id) {
      itemInfo = productsMap[item];
    } else {
      itemInfo = item;
    }
    return itemInfo?.id == currentProductVariation?.id;
  });

  if (!productOptions?.id) {
    productOptions = productsMap[productOptions];
  }

  if (!Array.isArray(productOptions?.steps?.[0]?.options)) {
    productOptions = productsMap[productOptions?.id];
  }

  if (!Array.isArray(productOptions?.steps?.[0]?.options)) {
    productOptions = productsMap[productID]?.items?.find((item) => {
      let itemInfo;
      if (!item?.id) {
        itemInfo = productsMap[item];
      } else {
        itemInfo = item;
      }
      return itemInfo?.id == currentProductVariation?.id;
    });

    if (!productOptions?.id) {
      productOptions = productsMap[productOptions];
    }
  }

  return (
    <>
      <div className={isSticky ? css.stickyheader : css.mobHeader}>
        <div className={css.headerBanner}>
          <div className={css.backButton}>
            <BackButton handleBack={() => handleBack(false)} />
          </div>
          <span className={css.stickyHeaderTitle}>{menuItem?.name}</span>
          <Button
            className={css.mobileResetBtn}
            size={intl.locale == 'en' ? 'small' : 'large'}
            color="secondary"
            variant="outlined"
            onClick={resetButton}
          >
            <FormattedMessage id={'customize_reset'} defaultMessage={'customize_reset'} />
          </Button>
        </div>
      </div>
      <div className={css.headerMobile}>
        <img
          src={`${selectedProduct?.assets[0]?.src}`}
          alt={`${menuItem?.name}`}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImg;
          }}
        />

        <div className={css.title}>{menuItem?.name}</div>
        <div className={css.desc}>{selectedProduct?.longDesc}</div>
      </div>
      <div className={`${css.productImage}`}>
        <img
          src={`${selectedProduct?.assets[0]?.src}`}
          alt={menuItem?.name}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImg;
            e.target.width = 150;
            e.target.height = 150;
            e.target.className = css.noImgFound;
          }}
        />
        {!isDesktop && <span className={css.productMobileDesc}>{customToShow?.description}</span>}
        {isDesktop && (
          <div className={css.productDetail}>
            <div className={css.heading}>
              <h3>{menuItem?.name}</h3>
            </div>
            {(customToShow.customized === 1 || customToShow.customized === true) && !removeCust ? (
              getCustomize()
            ) : (
              <div className={css.productDesc}>
                <div className={css.onlyDescription}>{selectedProduct?.longDesc}</div>
              </div>
            )}

            <div className={css.buttonDesktop}>
              <ProductAddToCart
                isDesktop={true}
                isBundleItem={isBundleItem}
                productID={productID}
                buttonText={
                  isBundleItem ? (
                    <FormattedMessage id="checkout_proceed" defaultMessage="Proceed" />
                  ) : locationSearch.has('cartId') ? (
                    <FormattedMessage id="update_cart" defaultMessage="Update Cart" />
                  ) : (
                    <FormattedMessage id="product_addtocart" defaultMessage="Add to cart" />
                  )
                }
                onClick={addCart}
                selectedProduct={selectedProduct}
                categoryID={categoryID}
                imgSrc={selectedProduct?.assets[0]?.src}
              />
            </div>
          </div>
        )}
      </div>
      <div className={`${css.groupTitle}`}>
        <div className={css.groupContainer}>
          <Tabs
            className={css.groupTabs}
            scrollButtons={'off'}
            variant={'scrollable'}
            orientation={isDesktop ? 'vertical' : 'horizontal'}
            value={tabValue}
            onChange={handleTabChange}
          >
            {renderTabs}
          </Tabs>
          {isDesktop && (
            <Button
              color="secondary"
              variant="outlined"
              size="medium"
              className={css.resetButton}
              onClick={() => checkReset()}
            >
              {intl.formatMessage({
                id: 'reset_customization',
                defaultMessage: 'Reset Customization',
              })}
            </Button>
          )}
        </div>
      </div>
      {/* RENDERING TABS  */}
      <div className={`${css.contentContainer} card-wrap`}>
        {/* RENDERING MENU VARIANTS */}
        {selectedProduct?.variants?.map((configGroup, ids) => {
          const title = configGroup?.subtitle;
          const uniqueName = `${configGroup.subtitle.replace(/[\W_]/g, '').split(' ').join('')}-${
            configGroup.id
          }`;

          if (!configGroup?.options?.length) {
            return null;
          }

          return (
            <ProductConfigurableGroup
              variationPrice={
                currentProductVariation?.price ||
                currentProductVariation?.specialPrice ||
                currentProductVariation?.originalPrice ||
                0
              }
              productID={productID}
              variationId={configGroup.id}
              selectedSize={setSelectedSize}
              setOptMainId={setOptMainId}
              isDesktop={isDesktop}
              uniqueName={uniqueName}
              title={title}
              variantImageBase={variantImageBase}
            />
          );
        })}
        {/* RENDERING PRODUCT OPTIONS */}
        {selectedProduct?.bundleTypeId == 'bundle' &&
          selectedProduct.steps?.map((optionGroup, idx) => {
            const key = `ProductOptionGroup-${optionGroup.id}-${optionGroup.type}`;
            const uniqueName = `${optionGroup.title.replace(/[\W_]/g, '').split(' ').join('')}-${
              optionGroup.id
            }`;
            return (
              <ProductOptionGroup
                productID={productID}
                uniqueName={uniqueName}
                resetDependent={resetDependent}
                setCheckDependent={setCheckDependent}
                checkDependent={checkDependent}
                mainItem={selectedProduct?.id}
                optionGroup={optionGroup}
                key={key}
                id={optionGroup.id}
                tabValue={tabValue}
                country={country}
                selectedProduct={selectedProduct}
                isDesktop={isDesktop}
                variantImageBase={variantImageBase}
              />
            );
          })}

        {(selectedProduct?.inSide || selectedProduct?.typeId === 'configurable') &&
          (Array.isArray(currentProductVariation?.steps?.[0]?.options)
            ? currentProductVariation
            : productOptions
          )?.steps?.map((optionGroup, idx) => {
            const key = `ProductOptionGroup-${optionGroup.id}-${optionGroup.type}`;
            const uniqueName = `${optionGroup.title.replace(/[\W_]/g, '').split(' ').join('')}-${
              optionGroup.id
            }`;
            return (
              <ProductOptionGroup
                productID={productID}
                uniqueName={uniqueName}
                resetDependent={resetDependent}
                setCheckDependent={setCheckDependent}
                checkDependent={checkDependent}
                mainItem={selectedProduct?.id}
                optionGroup={optionGroup}
                key={key}
                id={optionGroup.id}
                tabValue={tabValue}
                country={country}
                selectedProduct={selectedProduct}
                isDesktop={isDesktop}
                variantImageBase={variantImageBase}
              />
            );
          })}
        {/* RENDERING MENU CARD FOR MOBILE */}
        {!isDesktop && (
          <div className={css.ctaBar}>
            <div className={css.priceContainer}>
              <ProductAddToCart
                imgSrc={selectedProduct?.assets[0]?.src}
                isDesktop={false}
                isBundleItem={isBundleItem}
                productID={productID}
                buttonText={
                  isBundleItem ? (
                    <FormattedMessage id="checkout_proceed" defaultMessage="Proceed" />
                  ) : locationSearch.has('cartId') ? (
                    <FormattedMessage id="update_cart" defaultMessage="Update Cart" />
                  ) : (
                    <FormattedMessage id="product_addtocart" defaultMessage="Add to cart" />
                  )
                }
                onClick={addCart}
                selectedProduct={selectedProduct}
                categoryID={categoryID}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ProductCustomize;
